/**
 * 物料筛选行级贡献（与 backend/utils/statistics/statisticsMaterialLineContribution 对齐）
 */

export const hasStatisticsMaterialFilter = (filters) =>
	Boolean(filters) &&
	((filters.suppliers?.length ?? 0) > 0 ||
		(filters.brands?.length ?? 0) > 0 ||
		(filters.categories?.length ?? 0) > 0 ||
		(filters.products?.length ?? 0) > 0);

export const resolveStatisticsOrderLineItemAmount = (item) => {
	const price = Number(item?.sellingPrice);
	const qty = Number(item?.qty);
	if (Number.isFinite(price) && Number.isFinite(qty) && qty !== 0) return price * qty;
	if (Number.isFinite(price)) return price;
	return 0;
};

const normalizeLineText = (value) => String(value ?? '').trim();

const resolveItemProductId = (item) => {
	const product = item?.product;
	if (product == null || product === '') return '';
	if (typeof product === 'object') {
		if (product._id != null) return String(product._id);
	}
	return String(product);
};

/** 同行须满足所有已选物料条件；同字段多选为或 */
export const orderItemMatchesStatisticsMaterialFilter = (item, filters = {}) => {
	if (!hasStatisticsMaterialFilter(filters)) return true;

	if (filters.suppliers?.length) {
		const name = normalizeLineText(item?.supplierName);
		if (!filters.suppliers.map(String).includes(name)) return false;
	}
	if (filters.brands?.length) {
		const name = normalizeLineText(item?.brand);
		if (!filters.brands.map(String).includes(name)) return false;
	}
	if (filters.categories?.length) {
		const name = normalizeLineText(item?.category);
		if (!filters.categories.map(String).includes(name)) return false;
	}
	if (filters.products?.length) {
		const productId = resolveItemProductId(item);
		if (!filters.products.map(String).includes(productId)) return false;
	}
	return true;
};

export const resolveStatisticsMaterialContribution = (order, filters = {}) => {
	const orderTotal = Number(order?.totalPrice) || 0;
	const items = Array.isArray(order?.orderItems) ? order.orderItems : [];

	if (!hasStatisticsMaterialFilter(filters)) {
		return {
			active: false,
			amount: orderTotal,
			ratio: 1,
			matchedItems: items,
		};
	}

	const matchedItems = items.filter((item) => orderItemMatchesStatisticsMaterialFilter(item, filters));
	const amount = matchedItems.reduce((sum, item) => sum + resolveStatisticsOrderLineItemAmount(item), 0);
	const ratio = orderTotal > 0 ? amount / orderTotal : 0;

	return {
		active: true,
		amount,
		ratio,
		matchedItems,
	};
};

/** 再聚合用：匹配行金额 + 应收类按占比分摊；明细展示仍用原 order */
export const buildStatisticsMaterialScopedOrder = (order, filters = {}) => {
	const contribution = resolveStatisticsMaterialContribution(order, filters);
	if (!contribution.active) return order;

	const { amount, ratio, matchedItems } = contribution;
	return {
		...order,
		totalPrice: amount,
		orderItems: matchedItems,
		currentAccountsReceivable: (Number(order?.currentAccountsReceivable) || 0) * ratio,
		quasiReceivable: (Number(order?.quasiReceivable) || 0) * ratio,
		pendingPrepayment: (Number(order?.pendingPrepayment) || 0) * ratio,
		paidPrepayment: (Number(order?.paidPrepayment) || 0) * ratio,
		rewardSummary: order?.rewardSummary
			? {
					...order.rewardSummary,
					trueProfit: (Number(order.rewardSummary.trueProfit) || 0) * ratio,
				}
			: order?.rewardSummary,
	};
};

export const STATISTICS_MATERIAL_FILTER_HELP =
	'厂家 / 品牌 / 品类 / 品名按订单物料行统计：合同额仅计匹配行；应收、准应收、预付按「匹配行金额 ÷ 合同额」分摊；含匹配行的订单计 1 单。多条件须同一行同时满足。';
